import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import BlocksTable from './BlocksTable';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { SortAscendingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteBlockMutation,
  useGetBlocksWithEditQuery,
} from '../../../../../redux/services/blocks';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const BlocksPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const { data: blocks, isLoading, refetch } = useGetBlocksWithEditQuery();

  useEffect(() => {
    document.title = t('Bloky') + ' - FRI CMS';
  }, []); // Runs on mount

  const [deleteBlock, { isSuccess: isDeleteSuccess }] =
    useDeleteBlockMutation();

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Bloky')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať blok')}
        createUrl={routes.cmsBlocksCreate}
        permissionsBasic={'blocks'}
        mainActions={[
          {
            onClick: () => navigate(routes.cmsBlocksOrder),
            title: t('Zoradiť bloky'),
            icon: <SortAscendingOutlined />,
            permission: 'block.update',
          },
        ]}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <BlocksTable
            blocks={blocks}
            onDelete={(record) => deleteBlock(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsBlocksEdit}/${record.id}`)
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default BlocksPage;
